<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      unit="考务信息"
      edit-title
      id-key="ExamId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @details-opened="onDetailsOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="考点" prop="ExamPlace">
              {{data.ExamPlace}}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="人数" prop="StudentNumber">
              {{data.StudentNumber}}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="状态" prop="Status">
              {{data.EnrollType==1?"启用":"停用"}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="注意事项" prop="Note">
              <span style="white-space: pre-line" v-html="data.Note"></span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="row-tb-head">
              <span>场次信息</span>
            </div>
            <el-table class="tb-c-head" :data="data.Sesstions" border>
              <el-table-column label="时间" align="center">
                <template slot-scope="{row}">
                  {{$commonJs.toShortDatetimeString(row.StartTime)}} - {{$commonJs.toShortDatetimeString(row.EndTime)}}
                </template>
              </el-table-column>
              <el-table-column label="科目/内容" prop="Subject" width="200px" align="center"/>
            </el-table>
          </el-col>
        </el-row>
        <div style="margin: 12px 0 10px;">参加报名学生</div>
        <el-row>
          <el-col :span="24">
            <student-list ref="studentList">
            </student-list>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import studentList from './studentList';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    studentList,
  },
  data() {
    return {
      data: {
        ExamId: 0,
        ExamPlace: "",
        EnrollType: null,
        StudentNumber: null,
        Status: 1,
        Note: "",
        Sesstions: [],
      },
      isMB: this.$store.state.isMB,
      api: require("@/api/po/exam").default,
      rules: {
        ExamPlace: [{ required: true, message: "考点不能为空" }],
        EnrollType: [{ required: true, message: "报考类型不能为空" }],
        StudentNumber: [{ required: true, message: "人数不能为空" }],
      },
    };
  },
  methods: {
    onCreateOpened() {
    },
    onDetailsOpened(data) {
      if(data.Note) this.data.Note = data.Note.replaceAll(" ","&ensp;");
      this.$refs.studentList.getData({ ExamId: data.ExamId });
    },
    onBeforeSave() {

    },
    onClosed() {
      
    },
  }
};
</script>